// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Kz8C","title":"Header_title__1Yxtt","left":"Header_left__2ADqU","clinicName":"Header_clinicName__Ul-dx"};